<template>
  <v-card
    class="ma-5 remove-card-margin shadow card-radius"
    :height="$vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? '' : '730px'"
    :class="
      (isMac ? 'edited_scrollbar' : '') ||
      ($vuetify.breakpoint.xs ? 'px-4 ' : 'px-10')
    "
  >
    <v-card-title class="font-size-18 font-weight-bold dark-purple-text">
      {{
        getDashboardView == "company"
          ? "Employee Performance"
          : "Teams' Performance"
      }}
    </v-card-title>
    <v-card-text>
      <!-- Analysis -->
      <v-row class="mx-0">
        <!-- Top Completed -->
        <v-col :md="4" cols="12" class="my-3">
          <v-card
            height="240px"
            class="remove-card-margin elevation-0 theme-border"
          >
            <v-card-title
              class="dashboard-table-bg py-2 dark-purple-text font-size-12 font-weight-bold"
            >
              <span> Most Completed </span>
              <v-spacer></v-spacer>
              <span> Score </span>
            </v-card-title>
            <v-card-text class="y-scroll card-text-height">
              <v-skeleton-loader
                v-if="getDashboardLoaders.analysis"
                height="180px"
                class="mt-1"
                type="table-tbody"
                tile
              ></v-skeleton-loader>
              <div
                v-else
                :class="
                  getAnalysis &&
                  getAnalysis.top_complete &&
                  !getAnalysis.top_complete.length
                    ? 'd-flex justify-center align-center'
                    : 'dark-purple-text'
                "
              >
                <!-- no data -->
                <div
                  v-if="
                    getAnalysis.top_complete && !getAnalysis.top_complete.length
                  "
                  class="d-flex align-center justify-center"
                >
                  <!-- <v-icon size="40"> mdi-account-clock-outline </v-icon> -->
                  <div class="mt-3">No data found</div>
                </div>
                <div
                  v-else
                  v-for="member in getAnalysis.top_complete"
                  :key="member.id"
                  class="d-flex justify-center column-height align-center border-bottom column-height px-5 text-capitalize"
                  :class="$vuetify.breakpoint.xs ? 'ma-n2' : 'py-2'"
                >
                  <v-tooltip color="#DCD8F3" content-class="arrow-up" bottom>
                    <template #activator="{ on }">
                      <profileImage
                        v-show="member.image ? ':src' : ':username'"
                        :src="member.image"
                        inline
                        :username="member.name ? member.name : member.email"
                        :size="25"
                        :userProfile="true"
                        :circular="true"
                        :class="$vuetify.breakpoint.xs ? 'mr-2' : 'mr-3'"
                      >
                      </profileImage>
                      <span
                        v-on="on"
                        :style="
                          getDashboardView == 'departments'
                            ? 'max-width: 120px'
                            : ''
                        "
                        class="d-inline-block text-truncate w-1 font-size-14"
                        :class="member.name ? 'text-capitalize' : ''"
                        >{{ member.name ? member.name : member.email }}</span
                      >
                    </template>
                    <span
                      class="d-flex text-truncate font-size-14 dark-purple-text font-weight-bold"
                      :class="member.name ? 'text-capitalize' : ''"
                      >{{ member.name ? member.name : member.email }}</span
                    >
                  </v-tooltip>
                  <v-spacer></v-spacer>
                  <div
                    v-if="getDashboardView == 'departments'"
                    class="d-inline-block text-truncate"
                    :class="
                      member.department
                        ? 'text-capitalize'
                        : 'grey--text font-italic'
                    "
                  >
                    <v-chip
                      label
                      small
                      align-center
                      justify-center
                      class="d-inline-block text-truncate"
                      :class="
                        (member.department ? '' : 'grey--text') ||
                        ($vuetify.breakpoint.xs
                          ? 'dep-chip-color-xs'
                          : 'dep-chip-color')
                      "
                    >
                      <div
                        style="max-width: 160px"
                        class="d-inline-block text-truncate"
                      >
                        {{
                          member.department
                            ? member.department
                            : "No Department"
                        }}
                      </div>
                    </v-chip>
                  </div>
                  <v-spacer></v-spacer>
                  <span>{{ member.completed }}</span>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- Top Overdue -->
        <v-col :md="4" cols="12" class="my-3">
          <v-card
            height="240px"
            class="remove-card-margin elevation-0 theme-border"
          >
            <v-card-title
              class="dashboard-table-bg py-2 dark-purple-text font-size-12 font-weight-bold"
            >
              <span> Most Overdue </span>
              <v-spacer></v-spacer>
              <span> Score </span>
            </v-card-title>
            <v-card-text class="y-scroll card-text-height">
              <v-skeleton-loader
                v-if="getDashboardLoaders.analysis"
                height="180px"
                class="mt-1"
                type="table-tbody"
                tile
              ></v-skeleton-loader>
              <div
                v-else
                :class="
                  getAnalysis &&
                  getAnalysis.top_overdue &&
                  !getAnalysis.top_overdue.length
                    ? 'd-flex justify-center align-center'
                    : 'dark-purple-text'
                "
                class="y-scroll"
              >
                <!-- no data -->
                <div
                  v-if="
                    getAnalysis.top_overdue && !getAnalysis.top_overdue.length
                  "
                  class="d-flex flex-column justify-center"
                >
                  <!-- <v-icon size="40"> mdi-account-clock-outline </v-icon> -->
                  <div class="mt-3">No data found</div>
                </div>
                <div
                  v-else
                  v-for="member in getAnalysis.top_overdue"
                  :key="member.id"
                  class="d-flex align-center px-5 border-bottom column-height"
                  :class="$vuetify.breakpoint.xs ? 'ma-n2' : 'py-2'"
                >
                  <v-tooltip color="#DCD8F3" content-class="arrow-up" bottom>
                    <template #activator="{ on }">
                      <profileImage
                        v-show="member.image ? ':src' : ':username'"
                        :src="member.image"
                        inline
                        :username="member.name ? member.name : member.email"
                        :size="25"
                        :userProfile="true"
                        :circular="true"
                        class="mr-3"
                      >
                      </profileImage>
                      <span
                        v-on="on"
                        :style="
                          getDashboardView == 'departments'
                            ? 'max-width: 120px'
                            : ''
                        "
                        class="d-inline-block text-truncate w-name w-1"
                        :class="member.name ? 'text-capitalize' : ''"
                        >{{ member.name ? member.name : member.email }}</span
                      >
                    </template>
                    <span
                      class="d-inline-block text-truncate w-name font-weight-bold dark-purple-text"
                      :class="member.name ? 'text-capitalize' : ''"
                      >{{ member.name ? member.name : member.email }}</span
                    >
                  </v-tooltip>
                  <v-spacer></v-spacer>
                  <span
                    v-if="getDashboardView == 'departments'"
                    class="d-inline-block text-truncate"
                    :class="
                      member.department
                        ? 'text-capitalize'
                        : 'grey--text font-italic'
                    "
                  >
                    <v-chip
                      label
                      small
                      align-center
                      justify-center
                      :class="
                        (member.department ? '' : 'grey--text') ||
                        ($vuetify.breakpoint.xs
                          ? 'dep-chip-color-xs'
                          : 'dep-chip-color')
                      "
                    >
                      <div
                        class="d-inline-block text-truncate"
                        style="max-width: 160px"
                      >
                        {{
                          member.department
                            ? member.department
                            : "No Department"
                        }}
                      </div>
                    </v-chip></span
                  >
                  <v-spacer></v-spacer>
                  <span>{{ member.overdue }}</span>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- Top Assigned -->
        <v-col :md="4" cols="12" class="my-3">
          <v-card
            :style="$vuetify.breakpoint.xs ? 'height:240px' : 'height:240px'"
            class="remove-card-margin elevation-0 theme-border"
          >
            <v-card-title
              class="dashboard-table-bg py-2 dark-purple-text font-size-12 font-weight-bold"
            >
              <span> Most Assigned to others </span>
              <v-spacer></v-spacer>
              <span> Score </span>
            </v-card-title>
            <v-card-text class="y-scroll card-text-height">
              <v-skeleton-loader
                v-if="getDashboardLoaders.analysis"
                height="180px"
                class="mt-1"
                type="table-tbody"
                tile
              ></v-skeleton-loader>
              <div
                v-else
                :style="
                  $vuetify.breakpoint.xs
                    ? 'max-height: 125px'
                    : 'max-height: 230px'
                "
                :class="
                  getAnalysis &&
                  getAnalysis.top_assign &&
                  !getAnalysis.top_assign.length
                    ? 'd-flex justify-center align-start'
                    : 'dark-purple-text'
                "
                class="y-scroll"
              >
                <!-- no data -->
                <div
                  v-if="
                    getAnalysis.top_assign && !getAnalysis.top_assign.length
                  "
                  class="d-flex flex-column justify-center mt-3"
                >
                  <!-- <v-icon size="40"> mdi-account-clock-outline </v-icon> -->
                  <span>No data found</span>
                </div>
                <div
                  v-else
                  v-for="member in getAnalysis.top_assign"
                  :key="member.id"
                  class="d-flex align-center px-5 border-bottom column-height"
                  :class="$vuetify.breakpoint.xs ? 'ma-n2' : 'py-2'"
                >
                  <v-tooltip color="#DCD8F3" content-class="arrow-up" bottom>
                    <template #activator="{ on }">
                      <profileImage
                        v-show="member.image ? ':src' : ':username'"
                        :src="member.image"
                        inline
                        :username="member.name ? member.name : member.email"
                        :size="25"
                        :userProfile="true"
                        :circular="true"
                        class="mr-3"
                      >
                      </profileImage>
                      <span
                        v-on="on"
                        :style="
                          getDashboardView == 'departments'
                            ? 'max-width: 120px'
                            : ''
                        "
                        class="d-inline-block text-truncate w-name w-1"
                        :class="member.name ? 'text-capitalize' : ''"
                        >{{ member.name ? member.name : member.email }}</span
                      >
                    </template>
                    <span
                      class="d-inline-block text-truncate w-name w-1 dark-purple-text font-weight-bold"
                      :class="member.name ? 'text-capitalize' : ''"
                      >{{ member.name ? member.name : member.email }}</span
                    >
                  </v-tooltip>
                  <v-spacer></v-spacer>
                  <span
                    v-if="getDashboardView == 'departments'"
                    class="d-inline-block text-truncate"
                    :class="
                      member.department
                        ? 'text-capitalize'
                        : 'grey--text font-italic'
                    "
                  >
                    <v-chip
                      label
                      small
                      align-center
                      justify-center
                      :class="
                        (member.department ? '' : 'grey--text') ||
                        ($vuetify.breakpoint.xs
                          ? 'dep-chip-color-xs'
                          : 'dep-chip-color')
                      "
                    >
                      <div
                        class="d-inline-block text-truncate"
                        style="max-width: 160px"
                      >
                        {{
                          member.department
                            ? member.department
                            : "No Department"
                        }}
                      </div>
                    </v-chip></span
                  >
                  <v-spacer></v-spacer>
                  <span class="font-weight-bold dark-purple-text">{{
                    member.assigned_to_others
                  }}</span>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <!-- Permformers -->
      <v-row class="mx-0">
        <v-col :md="4" cols="12" class="my-3">
          <v-card
            :height="
              $vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? '' : '300px'
            "
            :class="isMac ? 'edited_scrollbar' : ''"
            class="elevation-0 theme-border"
          >
            <v-card-text>
              <!-- skeleton loader 1-->
              <v-row v-if="getDashboardLoaders.performers" no-gutters>
                <v-col>
                  <v-skeleton-loader
                    height="200"
                    class="mt-8"
                    type="table-tbody"
                    tile
                  ></v-skeleton-loader>
                </v-col>
              </v-row>
              <div class="d-flex" v-else>
                <!-- <div style="width: 50%"> -->
                <v-data-table
                  v-if="getPerformers"
                  :headers="
                    getDashboardView == 'departments'
                      ? departmentHeaders
                      : headers
                  "
                  :items="getPerformers.top_members"
                  hide-default-header
                  class="w-100 v-dashboard-employees-table"
                  disable-pagination
                  fixed-header
                  mobile-breakpoint="0"
                  :class="
                    isMac && getPerformers.top_members ? 'edited_scrollbar' : ''
                  "
                  height="298px"
                  hide-default-footer
                >
                  <template v-slot:[`body.prepend`]="{}">
                    <tr>
                      <td
                        class="sticky-header dashboard-table-bg"
                        style="border-top-left-radius: 4px"
                        :colspan="
                          getDashboardView == 'departments'
                            ? departmentHeaders.length
                            : headers.length
                        "
                      >
                        <div
                          class="font-size-14 font-weight-bold dark-purple-text w-100"
                        >
                          <span>Worked more than</span>

                          <v-menu
                            v-model="moreThanMenu"
                            :close-on-content-click="false"
                            offset-y
                            rounded
                            content-class=" bg-color"
                            min-width="50"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                depressed
                                v-bind="attrs"
                                v-on="on"
                                color="#A8A5C0"
                                class="text-capitalize ml-2 float-right"
                                small
                                outlined
                                max-width="90"
                                style="border-radius: 2px"
                              >
                                <span class="pl-1 dusty-purple-text">
                                  {{
                                    getPerformerMoreThan
                                      ? getPerformerMoreThan + " " + "Hours"
                                      : "Select"
                                  }}
                                </span>

                                <v-icon small class="px-1" color="#2a206a">
                                  mdi-chevron-down
                                </v-icon>
                              </v-btn>
                            </template>
                            <div :class="isMac ? 'edited_scrollbar' : ''">
                              <v-list
                                max-height="200"
                                class="pointer overflow-scroll"
                                width="100px"
                              >
                                <div
                                  v-for="value in moreThanHourRange()"
                                  :key="value"
                                  class="status-list-min-height caption listing-hover d-flex pointer"
                                  :class="
                                    getPerformerMoreThan == value
                                      ? 'bg-selected'
                                      : ''
                                  "
                                >
                                  <v-list-item-content
                                    @click="
                                      $store.commit('setPerformerFilter', {
                                        more_than: value,
                                      }),
                                        searchData()
                                    "
                                  >
                                    <span class="ml-2 text-capitalize">
                                      {{ value }}
                                    </span>
                                  </v-list-item-content>
                                </div>
                              </v-list>
                            </div>
                          </v-menu>
                        </div>
                      </td>
                      <!-- <td class="sticky-header dashboard-table-bg"></td> -->
                    </tr>
                  </template>
                  <template slot="no-data">
                    <div
                      class="d-flex justify-center align-center mt-n3"
                      style="height: 180px"
                    >
                      <div>
                        <!-- <div>
                            <v-icon size="40">
                              mdi-account-clock-outline
                            </v-icon>
                          </div> -->
                        <div>No data found</div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.name`]="{ item }">
                    <v-tooltip color="#DCD8F3" content-class="arrow-up" bottom>
                      <template #activator="{ on }">
                        <div class="d-flex">
                          <profileImage
                            v-show="item.image ? ':src' : ':username'"
                            :src="item.image"
                            inline
                            :username="item.name ? item.name : item.email"
                            :size="25"
                            :userProfile="true"
                            :circular="true"
                            class="mr-3"
                          >
                          </profileImage>
                          <span
                            v-on="on"
                            :class="item.name ? 'text-capitalize' : ''"
                            class="d-inline-block text-truncate dark-purple-text"
                            :style="
                              getDashboardView == 'departments'
                                ? 'max-width: 80px'
                                : ''
                            "
                          >
                            {{ item.name ? item.name : item.email }}
                          </span>
                        </div>
                      </template>
                      <span
                        class="d-inline-block text-truncate w-1 dark-purple-text font-weight-bold"
                      >
                        {{ item.name ? item.name : item.email }}
                      </span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.department`]="{ item }">
                    <span
                      class="d-inline-block text-truncate dark-purple-text"
                      :class="
                        item.department
                          ? 'd-inline-block text-capitalize'
                          : 'grey--text font-italic'
                      "
                      :style="
                        getDashboardView == 'departments'
                          ? 'max-width: 120px'
                          : ''
                      "
                    >
                      <v-chip
                        label
                        small
                        align-center
                        justify-center
                        :class="
                          (item.department ? '' : 'grey--text') ||
                          ($vuetify.breakpoint.xs
                            ? 'dep-chip-color-xs'
                            : 'dep-chip-color')
                        "
                      >
                        <div
                          class="d-inline-block text-truncate"
                          style="max-width: 160px"
                        >
                          {{
                            item.department ? item.department : "No department"
                          }}
                        </div>
                      </v-chip>
                    </span>
                  </template>
                  <template v-slot:[`item.sum`]="{ item }">
                    <span class="dark-purple-text font-weight-bold float-right">
                      {{ item.sum }}
                    </span>
                  </template>
                </v-data-table>
                <!-- </div> -->
                <!-- <v-divider
                  v-if="$mq > 'phone'"
                  vertical
                  class="dashboard-table-bg"
                  style="height: 298px"
                ></v-divider> -->
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <!-- Worked less than -->
        <v-col :md="4" cols="12" class="my-3">
          <v-card
            :height="
              $vuetify.breakpoint.sm || $vuetify.breakpoint.xs ? '' : '300px'
            "
            :class="isMac ? 'edited_scrollbar' : ''"
            class="elevation-0 theme-border"
          >
            <v-card-text>
              <!-- skeleton loader 1-->
              <v-row v-if="getDashboardLoaders.performers">
                <v-col>
                  <v-skeleton-loader
                    height="200"
                    class="mt-8"
                    type="table-tbody"
                    tile
                  ></v-skeleton-loader>
                </v-col>
              </v-row>
              <div v-else>
                <v-data-table
                  v-if="getPerformers"
                  :headers="
                    getDashboardView == 'departments'
                      ? departmentHeaders
                      : headers
                  "
                  :items="getPerformers.bottom_members"
                  hide-default-header
                  class="w-100 v-dashboard-employees-table table-border-color"
                  disable-pagination
                  fixed-header
                  mobile-breakpoint="0"
                  :class="isMac ? 'edited_scrollbar' : ''"
                  hide-default-footer
                  height="298px"
                  :calculate-widths="true"
                >
                  <template v-slot:[`body.prepend`]="{}">
                    <tr>
                      <td
                        :colspan="
                          getDashboardView == 'departments'
                            ? departmentHeaders.length
                            : headers.length
                        "
                        class="sticky-header dashboard-table-bg"
                      >
                        <div
                          class="w-100 font-size-14 font-weight-bold dark-purple-text"
                        >
                          <span> Worked less than</span>
                          <v-menu
                            v-model="lessThanMenu"
                            :close-on-content-click="false"
                            offset-y
                            rounded
                            content-class=" bg-color"
                            min-width="50"
                          >
                            <template v-slot:activator="{ on, attrs }">
                              <v-btn
                                depressed
                                v-bind="attrs"
                                v-on="on"
                                color="#A8A5C0"
                                class="text-capitalize ml-2 float-right"
                                small
                                outlined
                                max-width="90"
                                style="border-radius: 2px"
                              >
                                <span class="pl-1 dusty-purple-text">
                                  {{
                                    getPerformerLessThan
                                      ? getPerformerLessThan + " " + "Hours"
                                      : "Select"
                                  }}
                                </span>

                                <v-icon small class="px-1" color="#2a206a">
                                  mdi-chevron-down
                                </v-icon>
                              </v-btn>
                            </template>
                            <div :class="isMac ? 'edited_scrollbar' : ''">
                              <v-list
                                max-height="200"
                                class="pointer overflow-scroll"
                                width="100px"
                              >
                                <div
                                  v-for="value in lessThanHourRange()"
                                  :key="value"
                                  class="status-list-min-height caption listing-hover d-flex pointer text-capitalize"
                                  :class="
                                    getPerformerLessThan == value
                                      ? 'bg-selected'
                                      : ''
                                  "
                                >
                                  <v-list-item-content
                                    @click="
                                      $store.commit('setPerformerFilter', {
                                        less_than: value,
                                      }),
                                        searchData()
                                    "
                                  >
                                    <span
                                      class="ml-2 text-capitalize w-1"
                                      :class="$vuetify.breakpoint.xs ? '' : ''"
                                    >
                                      {{ value }}
                                    </span>
                                  </v-list-item-content>
                                </div>
                              </v-list>
                            </div>
                          </v-menu>
                        </div>
                      </td>
                      <!-- <td class="sticky-header dashboard-table-bg"></td> -->
                      <!-- <td
                          class="sticky-header dashboard-table-bg"
                          style="border-top-right-radius: 4px"
                        ></td> -->
                    </tr>
                  </template>
                  <template slot="no-data">
                    <div
                      class="d-flex justify-center align-center mt-n3"
                      style="height: 180px"
                    >
                      <div>
                        <!-- <div>
                            <v-icon size="40">
                              mdi-account-clock-outline
                            </v-icon>
                          </div> -->
                        <div>No data found</div>
                      </div>
                    </div>
                  </template>
                  <template v-slot:[`item.name`]="{ item }">
                    <v-tooltip color="#DCD8F3" content-class="arrow-up" bottom>
                      <template #activator="{ on }">
                        <div
                          class="d-flex"
                          :class="$vuetify.breakpoint.xs ? 'ma-n2' : ''"
                        >
                          <profileImage
                            v-show="item.image ? ':src' : ':username'"
                            :src="item.image"
                            inline
                            :username="item.name ? item.name : item.email"
                            :size="25"
                            :userProfile="true"
                            :circular="true"
                            class="mr-3"
                          >
                          </profileImage>
                          <span
                            v-on="on"
                            class="d-inline-block text-truncate w-1 text-capitalize dark-purple-text"
                            :style="
                              getDashboardView == 'departments'
                                ? 'max-width: 80px'
                                : ''
                            "
                          >
                            {{ item.name ? item.name : item.email }}
                          </span>
                        </div>
                      </template>
                      <span
                        class="d-inline-block w-1 text-capitalize dark-purple-text font-weight-bold"
                      >
                        {{ item.name ? item.name : item.email }}
                      </span>
                    </v-tooltip>
                  </template>
                  <template v-slot:[`item.department`]="{ item }">
                    <span
                      class="d-inline-block text-truncate"
                      :class="
                        item.department
                          ? 'text-capitalize'
                          : 'grey--text font-italic'
                      "
                      style="max-width: 190px"
                    >
                      <v-chip
                        label
                        small
                        align-center
                        justify-center
                        :class="
                          (item.department ? '' : 'grey--text') ||
                          ($vuetify.breakpoint.xs
                            ? 'dep-chip-color-xs'
                            : 'dep-chip-color')
                        "
                        style="z-index: 0.9"
                      >
                        <div
                          class="d-inline-block text-truncate"
                          style="max-width: 160px"
                        >
                          {{
                            item.department ? item.department : "No department"
                          }}
                        </div>
                      </v-chip>
                    </span>
                  </template>
                  <template v-slot:[`item.sum`]="{ item }">
                    <span class="dark-purple-text font-weight-bold float-right">
                      {{ item.sum }}
                    </span>
                  </template>
                </v-data-table>
              </div>
            </v-card-text></v-card
          >
        </v-col>
        <!-- Inactive members -->
        <v-col :md="4" cols="12" class="my-3">
          <v-card
            height="300px"
            class="remove-card-margin elevation-0 theme-border"
          >
            <v-card-title class="dashboard-table-bg py-2">
              <span
                class="dark-purple-text text-capitalize font-size-14 font-weight-bold"
              >
                inactive members
              </span>
            </v-card-title>

            <v-card-text>
              <v-skeleton-loader
                v-if="getDashboardLoaders.performers"
                height="200px"
                class="mt-1"
                type="table-tbody"
                tile
              ></v-skeleton-loader>
              <div
                v-else
                style="height: 230px"
                :class="
                  getPerformers &&
                  getPerformers.inactive_members &&
                  !getPerformers.inactive_members.length
                    ? 'd-flex justify-center align-center'
                    : ''
                "
                class="y-scroll"
              >
                <!-- <span
                  v-if="
                    getPerformers &&
                    getPerformers.inactive_members &&
                    getPerformers.inactive_members.length
                  "
                >
                  <div
                    v-for="member in getPerformers.inactive_members"
                    :key="member.id"
                  >
                    <v-row class="ml-1 no-tracked-row">
                      <v-col
                        :md="4"
                        :sm="9"
                        :lg="7"
                        :xl="9"
                        :cols="$vuetify.breakpoint.xs ? '7' : '9'"
                      >
                        <span
                          class="d-inline-block text-truncate font-size-12 dark-purple-text"
                          :class="member.name ? 'text-capitalize' : ''"
                          :style="
                            $vuetify.breakpoint.xs ||
                            $vuetify.breakpoint.sm ||
                            $vuetify.breakpoint.md
                              ? 'max-width: 140px'
                              : 'max-width: 170px'
                          "
                        >
                          {{ member.name ? member.name : member.email }}
                        </span>
                      </v-col>
                      <v-col
                        :md="4"
                        :sm="9"
                        :lg="7"
                        :xl="9"
                        :cols="$vuetify.breakpoint.xs ? '7' : '9'"
                      >
                        <span
                          class="d-inline-block text-truncate font-size-12 dark-purple-text"
                          :class="
                            member.department
                              ? 'text-capitalize'
                              : 'grey--text font-italic'
                          "
                          :style="
                            $vuetify.breakpoint.xs ||
                            $vuetify.breakpoint.sm ||
                            $vuetify.breakpoint.md
                              ? 'max-width: 140px'
                              : 'max-width: 170px'
                          "
                        >
                          {{
                            member.department
                              ? member.department
                              : "No department"
                          }}
                        </span>
                      </v-col>
                      <v-col
                        :md="4"
                        :sm="3"
                        :lg="5"
                        :xl="3"
                        :cols="$vuetify.breakpoint.xs ? '5' : '3'"
                      >
                        <span class="text-capitalize">
                          <v-chip
                            small
                            :color="
                              member.status == 'inactive'
                                ? 'grey lighten-3'
                                : ''
                            "
                            :class="
                              member.status == 'inactive'
                                ? 'disable-chip font-weight-bold'
                                : 'blue-chip-color'
                            "
                            class="inactive-chip d-flex justify-center"
                          >
                            <span class="font-size-7">
                              {{
                                member.status == "inactive"
                                  ? "Invitation Not Accepted"
                                  : "No Task Found"
                              }}</span
                            >
                          </v-chip>
                        </span>
                      </v-col>
                    </v-row>
                  </div>
                </span> -->

                <div
                  v-if="
                    getPerformers &&
                    getPerformers.inactive_members &&
                    !getPerformers.inactive_members.length
                  "
                >
                  <!-- <div>
                    <v-icon size="40" class="ml-5 mt-n6">
                      mdi-account-clock-outline
                    </v-icon>
                  </div> -->
                  <div>No data found</div>
                </div>

                <div
                  v-if="
                    getPerformers &&
                    getPerformers.inactive_members &&
                    getPerformers.inactive_members.length
                  "
                >
                  <div
                    v-for="member in getPerformers.inactive_members"
                    :key="member.id"
                    class="d-flex align-center px-2 py-2 dark-purple-text"
                  >
                    <v-tooltip color="#DCD8F3" content-class="arrow-up" bottom>
                      <template #activator="{ on }">
                        <span
                          v-on="on"
                          :style="
                            getDashboardView == 'departments'
                              ? 'max-width: 120px'
                              : ''
                          "
                          class="d-inline-block mr-3 text-truncate font-size-12 w-name w-1 text-capitalize"
                          :class="member.name ? 'text-capitalize' : ''"
                          >{{ member.name ? member.name : member.email }}</span
                        >
                      </template>
                      <span
                        class="d-inline-block text-truncate w-name dark-purple-text font-weight-bold"
                        :class="member.name ? 'text-capitalize' : ''"
                        >{{ member.name ? member.name : member.email }}</span
                      >
                    </v-tooltip>
                    <v-spacer></v-spacer>
                    <span
                      v-if="getDashboardView == 'departments'"
                      class="text-truncate mx-2 d-inline-block font-size-12"
                      :class="
                        member.department
                          ? 'text-capitalize'
                          : 'grey--text font-italic'
                      "
                    >
                      <v-chip
                        label
                        small
                        class="d-flex justify-center"
                        :class="
                          (member.department ? '' : 'grey--text') ||
                          ($vuetify.breakpoint.xs
                            ? 'dep-chip-color-xs'
                            : 'dep-chip-color')
                        "
                      >
                        <span
                          class="d-inline-block text-truncate"
                          style="max-width: 110px"
                        >
                          {{
                            member.department
                              ? member.department
                              : "No Department"
                          }}
                        </span>
                      </v-chip></span
                    >
                    <v-spacer></v-spacer>
                    <v-chip
                      label
                      small
                      :color="
                        member.status == 'inactive' ? 'grey lighten-3' : ''
                      "
                      :class="
                        member.status == 'inactive'
                          ? 'disable-chip font-weight-bold'
                          : 'blue-chip-color'
                      "
                      class="inactive-chip d-flex justify-center"
                    >
                      <span
                        style="max-width: 110px"
                        class="d-inline-block text-truncate"
                        >{{
                          member.status == "inactive"
                            ? "Invitation Not Accepted"
                            : "No Task Found"
                        }}</span
                      >
                    </v-chip>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      moreThanMenu: false,
      lessThanMenu: false,
      headers: [
        {
          text: "Name",
          value: "name",
          sortable: false,
          class: "dashboard-table-bg",
        },
        {
          text: "Time",
          value: "sum",
          sortable: false,
          class: "dashboard-table-bg",
        },
      ],
      departmentHeaders: [
        {
          text: "Name",
          value: "name",
          sortable: false,
          class: "dashboard-table-bg",
        },
        {
          text: "Department",
          value: "department",
          sortable: false,
        },
        {
          text: "Time",
          value: "sum",
          sortable: false,
        },
      ],
    };
  },
  components: {
    profileImage: () => import("@/components/Includes/ProfileImage"),
  },
  computed: {
    ...mapGetters([
      "getDashboardDateFilter",
      "getPerformerMoreThan",
      "getPerformerLessThan",
      "getPerformers",
      "getDashboardView",
      "getDashboardMember",
      "getLeaderIdFilter",
      "getSelectedCompany",
      "getLoggedInUser",
      "getDashboardLoaders",
      "getAnalysis",
      "getDashboardStartDate",
    ]),
  },
  watch: {
    getDashboardStartDate(value) {
      if (value) {
        let less_than = this.lessThanHourRange();
        let more_than = this.moreThanHourRange();
        this.$store.commit("setPerformerFilter", {
          more_than: more_than[0],
          less_than: less_than[0],
        });
        this.searchData();
      }
    },
    getDashboardView() {
      this.searchData();
    },
    getDashboardMember(value, oldValue) {
      if (value && oldValue) this.searchData();
    },
  },
  methods: {
    searchData() {
      this.$store.dispatch("fetchTopPerformers");
      this.$store.dispatch("fetchAnalysis");
    },
    lessThanHourRange() {
      if (this.getDashboardDateFilter == "Today") return [2, 4, 6, 8, 10];
      if (this.getDashboardDateFilter == "Yesterday")
         return [14, 28, 42, 56, 70];
      if (this.getDashboardDateFilter == "Last 7 days")
        return [10, 20, 30, 40, 50 , 100];
      if (this.getDashboardDateFilter == "Last 30 days")
        return [30 , 40, 50, 80 , 100, 120, 150, 200];
      if (this.getDashboardDateFilter == "This month") {
        return [30 , 40, 50, 80 , 100, 120, 150, 200];
      }
      if (this.getDashboardDateFilter == "All time")
        return [450, 500, 550, 600, 650];
      else return [];
    },
    moreThanHourRange() {
      if (this.getDashboardDateFilter == "Today") return [2, 4, 6, 8, 10];
      if (this.getDashboardDateFilter == "Yesterday")
        return [14, 28, 42, 56, 70];
      if (this.getDashboardDateFilter == "Last 7 days")
        return [10, 20, 30, 40, 50 , 100];
      if (this.getDashboardDateFilter == "Last 30 days")
        return [30 , 40, 50, 80 , 100, 120, 150, 200];
      if (this.getDashboardDateFilter == "This month") {
        return [30 , 40, 50, 80 , 100, 120, 150, 200];
      }
      if (this.getDashboardDateFilter == "All time")
        return [450, 500, 550, 600, 650];
      else return [];
    },
  },
  mounted() {
    this.searchData();
  },
};
</script>
<style scoped>
.card-text-height {
  height: 192px;
}
.column-height {
  height: 48px !important;
}
.font-size-7 {
  font-size: 7px;
}

.w-1 {
  width: 135px !important;
}
.font-size-16 {
  font-size: 16px;
}
.header-dropdown-btn {
  border: 1px #2a206a solid !important;
  background-color: transparent !important;
}
.inactive-chip {
  width: 130px !important;
}
.no-tracked-row {
  margin-left: 12px;
  margin-top: -12px;
  margin-right: 12px;
}
.disable-chip {
  font-size: 10.5px !important;
  color: #313a5a !important;
}
.remove-card-margin .v-card__subtitle,
.v-card__text {
  padding: 0px;
}
.col-dimensions {
  height: 48px;
  width: 32%;
  min-width: 400px;
}
</style>
<style>
.sticky-header {
  position: sticky;
  top: 0;
  /* background-color: yellow !important; */
}

.v-dashboard-employees-table tr:hover:not(.v-table__expanded__content) {
  background: white !important;
}
</style>
